// extracted by mini-css-extract-plugin
export default {"tableCard":"TableLayout_tableCard__go5eu"};